// extracted by css-extract-rspack-plugin
export default {"sailing-plan":"sailing-plan-pxsj_3","sailingPlan":"sailing-plan-pxsj_3","sailing-plan-apply":"sailing-plan-apply-fRHXtY","sailingPlanApply":"sailing-plan-apply-fRHXtY"};